export default {
  register: {
    title: 'Mag-sign Up',
    username: 'Username',
    phone: 'Numero ng Telepono',
    phoneCode: 'Code',
    email: 'Email',
    password: 'Password',
    captcha: 'Captcha',
    smsCode: 'SMS Code',
    emailCode: 'Email Code',
    verificationCode: 'Email code',
    invitationCode: 'Invitation Code',
    loading: 'Naglo-load...',
    send: 'Ipadala',
    sendCode: 'Magpadala ng Code',
    signUp: 'Mag-sign Up',
    contactUs: 'Makipag-ugnayan？',
    haveAccount: 'Mayroon nang account?',
    signIn: 'Mag-sign In',
    loginNow: 'Mag-sign In',
    or: 'O',
    orSignUpWith: 'O mag-sign up gamit ang',
    methodUsername: 'Username',
    methodPhone: 'Telepono',
    methodEmail: 'Email',
    codeOptional: 'Code (Opsyonal)',
    privacyPolicy: 'Kinukumpirma ko na ako ay higit sa 18 taong gulang at tinatanggap ang',
    privacyPolicyLink: 'Privacy Policy',
    and: 'at',
    termsConditions: 'Terms & Conditions',
    vault: 'Kabaong',
    receivePromos: 'Tumanggap ng Email Promos',
    usernameRequired: 'Kailangan ang username',
    usernameInvalid: 'Ang username ay maaaring maglaman lamang ng mga titik, numero at underscore',
    phoneRequired: 'Kailangan ang numero ng telepono',
    phoneInvalid: 'Hindi wastong format ng numero ng telepono',
    emailRequired: 'Kailangan ang email',
    emailInvalid: 'Hindi wastong format ng email',
    passwordRequired: 'Kailangan ang password',
    passwordInvalid: 'Ang password ay hindi nakakatugon sa mga kinakailangan',
    captchaRequired: 'Kailangan ang captcha',
    smsCodeRequired: 'Kailangan ang SMS code',
    emailCodeRequired: 'Kailangan ang email code',
    privacyPolicyRequired: 'Mangyaring tanggapin ang Privacy Policy at Terms & Conditions',
    passwordHintLow: 'Hindi bababa sa 6 na digit',
    passwordHintMedium: 'Hindi bababa sa 6 na character na may mga titik at numero',
    passwordHintHigh: 'Hindi bababa sa 6 na character na may mga titik, numero at simbolo',
    // Format validation
    usernameFormat: 'Letra, numero at _ lamang',
    emailFormat: 'Hindi wastong format ng email',
    // Toast messages
    smsCodeSent: 'Naipadala ang SMS code',
    emailCodeSent: 'Naipadala ang email code',
    smsCodeFailed: 'Nabigo ang pagpapadala ng SMS code',
    emailCodeFailed: 'Nabigo ang pagpapadala ng email code',
    registerSuccess: 'Matagumpay ang pagpaparehistro',
    registerFailed: 'Nabigo ang pagpaparehistro',
    // Google sign in
    signInWithGoogle: 'Mag-sign in gamit ang Google+'
  }
};
